<script setup>
  import { ref, computed } from 'vue'
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

  const { $BRAND } = useConfigurationGlobals()

  const imageBaseUrl = 'https://cdn-consumer.weatherflow.com/lifestyle/images/404/'
  const defaultImage = '404_default.webp'
  const brandImages = {
    fishweather: '404_fishweather.webp',
    ikitesurf: '404_ikitesurf.webp',
    iwindsurf: '404_iwindsurf.webp',
    sailflow: '404_sailflow.webp'
  }

  const isError = new URLSearchParams(window.location.search).has('error')
  const headline = isError ? 'Oops... there was an error' : 'Page not found'
  const message = isError
    ? 'Something went wrong while loading this page. Please try again in a few minutes.'
    : "The page you're looking for doesn't exist or has been moved."

  const imageFailed = ref(false)

  const imageUrl = computed(() => {
    if (imageFailed.value) return `${imageBaseUrl}${defaultImage}`

    const brandImage = brandImages[($BRAND || '').toLowerCase()] || defaultImage
    return `${imageBaseUrl}${brandImage}`
  })

  const handleImageError = () => {
    if (!imageUrl.value.endsWith(defaultImage)) imageFailed.value = true
  }
</script>

<template>
  <div class="jwx-page-not-found">
    <div class="jwx-page-not-found__hero">
      <img
        class="jwx-page-not-found__image"
        :src="imageUrl"
        alt="Page not found"
        @error="handleImageError"
      />
      <h1 class="jwx-page-not-found__headline">{{ headline }}</h1>
    </div>
    <p class="jwx-page-not-found__message">{{ message }}</p>
    <a class="jwx-page-not-found__home-link" href="/">Back to the homepage</a>
  </div>
</template>
